import React from 'react';
import {CommissionPopup} from '../../Customers/components/customers-table/CommissionPopup'


export function AddEditCommissionColumnFormatter(cellContent) {
  return <CommissionPopup {...cellContent}/>
}
